@if (product) {
<vision2-subnav
    [productData]="product"
    (onRequestOpen)="openModal($event)"
></vision2-subnav>
<div class="product-page">
    <div class="container py-4">
        <div class="row justify-content-center py-4">
            <div class="col-12 col-md-10 col-lg-7">
                <div class="row">
                    <div class="col">
                        @if (categorySlug === 'strength') {
                        <h1
                            [innerHTML]="product['sku']"
                            class="equipment-code small text-blue-300 fst-italic fw-normal"
                        ></h1>
                        }
                        <h1
                            [innerHTML]="webDisplayName"
                            class="equipment-name text-blue-300"
                        ></h1>
                        @if (product?.activeConsole?.webDisplayName) {
                        <div class="console pl-0 mb-1">
                            <p
                                [innerHTML]="
                                    'PRODUCT-PAGE_GLOBAL_CONSOLE-WITH_TEXT'
                                        | translate
                                "
                                class="d-inline mb-0"
                            ></p>
                            <p
                                [innerHTML]="
                                    product?.activeConsole?.webDisplayName
                                "
                                class="console-name d-inline mb-0"
                            ></p>
                        </div>
                        }
                        <div
                            [innerHTML]="
                                product['product-description']
                                    | translate : 'markdown'
                            "
                            class="mb-3"
                        ></div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="request-quote">
                            <button
                                (click)="openModal('requestQuote')"
                                (keydown.enter)="openModal('requestQuote')"
                                [innerHTML]="
                                    'PRODUCT-PAGE_GLOBAL_REQUEST-A-QUOTE_TEXT'
                                        | translate
                                "
                                [ngClass]="'btn btn-outline-primary'"
                            ></button>
                        </div>
                    </div>
                    <div class="col-12 mb-3 mb-lg-4 pb-3 pb-lg-4">
                        @if (sellsheetLink) {
                        <a
                            [href]="sellsheetLink"
                            target="_blank"
                            class="icon-link p-0 text-decoration-none align-items-start"
                        >
                            <span
                                [innerHtml]="
                                    'PRODUCT-PAGE_GLOBAL_SELL-SHEET_TEXT'
                                        | translate
                                "
                                role="button"
                            ></span>
                            <span>
                                <img
                                    [src]="
                                        'GLOBAL_ARROW-RIGHT_ICON_URL'
                                            | translate
                                    "
                                    [alt]="
                                        'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT'
                                            | translate
                                    "
                                    class="bi arrow-icon align-baseline"
                                />
                            </span>
                        </a>
                        }
                    </div>
                </div>

                @if (product.consoles.length > 1) {
                <div class="row">
                    <div class="col-12">
                        <h4
                            [innerHTML]="
                                'PRODUCT-PAGE_GLOBAL_CONSOLE-SELECT_TEXT'
                                    | translate
                            "
                            class="mb-2"
                        ></h4>

                        <div class="console-select d-flex flex-row">
                            @for (console of product.consoles; track console;) {
                            <div
                                (click)="selectConsole(console['console-name'])"
                                (keydown.enter)="
                                    selectConsole(console['console-name'])
                                "
                                class="console-option me-1"
                                role="button"
                                (mouseenter)="
                                    setTooltipText(
                                        console['tooltip-heading'],
                                        console['tooltip-text']
                                    )
                                "
                                [content-type]="'template'"
                                [tooltip]="$any(Tooltip)"
                                contentType="template"
                                placement="bottom"
                                [hideDelay]="0"
                            >
                                <ng-container> </ng-container>
                                <img
                                    [ngClass]="{
                                                active:
                                                    +console['console-pdb-id'] ===
                                                    +(product?.activeConsole?.['console-pdb-id'] || 0)
                                            }"
                                    [src]="console?.consoleImage?.cdnUrl"
                                    [alt]="console?.['webDisplayName']"
                                    class="img-thumbnail rounded-0"
                                    [tabIndex]="0"
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>
                }
            </div>

            <div class="col-12 col-md-10 col-lg-5">
                <ng-template #productImage>
                    <img
                        [src]="product?.images?.[activeImageIndex]?.cdnUrl"
                        [alt]="product?.images?.[activeImageIndex]?.title"
                        class="img-fluid"
                        fetchpriority="high"
                    />
                </ng-template>

                @if (isBrowser) {
                <!-- Pinch Zoom uses window object -->
                <pinch-zoom
                    [wheel]="false"
                    [transition-duration]="0"
                    backgroundColor="rgba(0,0,0,0)"
                    [ngStyle]="{ '--zoom-icons': translatedIcons }"
                    [tabIndex]="0"
                >
                    <img
                        [src]="product.images?.[activeImageIndex]?.cdnUrl"
                        [alt]="product.images?.[activeImageIndex]?.title"
                        class="img-fluid"
                        fetchpriority="high"
                    />
                </pinch-zoom>
                } @else {
                <!-- Fallback img for SEO -->
                <img
                    [src]="product.images?.[activeImageIndex]?.cdnUrl"
                    [alt]="product.images?.[activeImageIndex]?.title"
                    class="img-fluid"
                    fetchpriority="high"
                />
                }

                <div class="row justify-content-center mt-4">
                    <div class="col-12">
                        <div class="gallery-select d-flex flex-row flex-wrap">
                            @for (thumbnail of product?.images; track thumbnail;
                            let index = $index) {
                            <div
                                (click)="changeActiveImage(index)"
                                (keydown.enter)="changeActiveImage(index)"
                                class="gallery-option me-1"
                                role="button"
                            >
                                <img
                                    [ngClass]="{
                                        active: activeImageIndex === index
                                    }"
                                    [src]="thumbnail?.cdnUrl"
                                    [alt]="thumbnail?.title"
                                    class="img-thumbnail rounded-0"
                                    [tabIndex]="0"
                                />
                            </div>
                            } @for (video of product?.videos; track video;) {
                            <div class="gallery-option me-1" role="button">
                                <img
                                    (click)="
                                        openModal(
                                            'productVideo',
                                            video['video-id']
                                        )
                                    "
                                    (keydown.enter)="
                                        openModal(
                                            'productVideo',
                                            video['video-id']
                                        )
                                    "
                                    [src]="video?.['thumbnail-image']"
                                    [alt]="video?.title"
                                    class="img-thumbnail rounded-0"
                                    [tabIndex]="0"
                                />
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
} @if (product) {
<vision2-section-0 [productData]="product"></vision2-section-0>

<vision2-section-1 [productData]="product"></vision2-section-1>

<vision2-section-2 [productData]="product"></vision2-section-2>

<vision2-section-3 [productData]="product"></vision2-section-3>

<vision2-section-4 [productData]="product"></vision2-section-4>

<vision2-section-5 [productData]="product"></vision2-section-5>

<vision2-section-6 [productData]="product"></vision2-section-6>

<vision2-section-7 [productData]="product"></vision2-section-7>

<vision2-section-8 [productData]="product"></vision2-section-8>
}

<ng-template #loading let-removePadding="removePadding">
    <div [class.p-4]="!removePadding" class="d-flex justify-content-center">
        <div
            [class.m-4]="!removePadding"
            class="spinner-border text-primary"
            role="status"
        >
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</ng-template>

<ng-template #Tooltip>
    <div class="text-start">
        <strong [innerHtml]="tooltipTitle"></strong>
        <small class="d-block" [innerHtml]="tooltipText"></small>
    </div>
</ng-template>

<div #productModal>
    @if (currentModal) {
    <brand-modal
        (onClose)="closeModal($event)"
        id="productVideo"
        modalDialogClass="modal-video modal-dialog-centered modal-max-width"
        modalContentClass="bg-transparent"
    >
        @if (videoLoaded && videoData) {
        <brand-video [videoData]="videoData"></brand-video>
        }
    </brand-modal>
    <brand-modal
        (onClose)="closeModal($event)"
        modalContentClass="text-left bg-light py-5 py-lg-7 px-0 px-sm-1"
        modalDialogsClass="modal-dialog-centered modal-max-width"
        id="requestQuote"
    >
        <vision2-request-quote [productData]="product"></vision2-request-quote>
    </brand-modal>
    }
</div>
